import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import NgpTextField from '../../../form/NgpTextField';
import NgpIpAddressField from '../../../form/NgpIpAddressField';
import { DescriptionField } from '../InfrastructureFieldComponents';
import { IPADDRESS_FIELD, LABEL_IP_ADDRESS, NAME_FIELD } from '../InfrastructureConstants';
import useNgpFormContext from '../../../../utilities/NgpFormContextProviderUtilities';
import { useDeviceInfraContext } from './DeviceInfraContext';
import { LABEL_MANUAL_NAME, MANUAL_NAME_FIELD } from './DeviceConstants';
import DeviceIpSelector from './DeviceIpSelector';

const IP_ADDRESS_SIZE = 40;
const IP_ADDRESS_MAX_LENGTH = 45;
const NAME_SIZE = 40;
const NAME_MAX_LENGTH = 128;

/**
 * Displays common form fields for device detail.
 * New device: editable IP input + name + description.
 * Existing device: Monitoring IP selector + name + description.
 * Applies portal/ui-compatible fallback: manualName = manualName || name
 */
const DeviceCommonFields = () => {
    const { isCreateAction } = useDeviceInfraContext();
    const { formData } = useNgpFormContext();
    const { setValue } = useFormContext();

    // Sync name from formData: use manualName if set, fall back to auto-discovered name.
    // Always update on formData change to handle in-page navigation between detail records.
    useEffect(() => {
        if (isCreateAction) {
            return;
        }
        if (formData) {
            const name = formData[MANUAL_NAME_FIELD] || formData[NAME_FIELD] || '';
            setValue(MANUAL_NAME_FIELD, name);
        }
    }, [formData, setValue, isCreateAction]);

    return (
        <>
            {isCreateAction ? (
                <NgpIpAddressField
                    fieldName={IPADDRESS_FIELD}
                    label={LABEL_IP_ADDRESS}
                    inputProps={{ size: IP_ADDRESS_SIZE, maxLength: IP_ADDRESS_MAX_LENGTH }}
                    required
                    validateCollectorScope
                    validateMultiHomed
                    isEditMode={!isCreateAction}
                />
            ) : (
                <DeviceIpSelector />
            )}
            <NgpTextField
                fieldName={MANUAL_NAME_FIELD}
                label={LABEL_MANUAL_NAME}
                inputProps={{ size: NAME_SIZE, maxLength: NAME_MAX_LENGTH }}
            />
            <DescriptionField />
        </>
    );
};

export default DeviceCommonFields;
